import React from "react";

const WarningLocation = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" rx="32" fill="#FFF8ED" />
    <path
      d="M44 30.6673C44 24.0007 38.6667 19.334 32 19.334C25.3333 19.334 20 24.0007 20 30.6673C20 37.334 28 44.2229 32 46.6673C36 44.2229 44 37.334 44 30.6673Z"
      stroke="#BD7100"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36 31.334C36 33.5431 34.2091 35.334 32 35.334C29.7909 35.334 28 33.5431 28 31.334C28 29.1248 29.7909 27.334 32 27.334C34.2091 27.334 36 29.1248 36 31.334Z"
      stroke="#BD7100"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

WarningLocation.propTypes = {};

export default WarningLocation;
